/* eslint-disable react/button-has-type, react/jsx-props-no-spreading  */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from './Button';

import FormArrowIcon from '../icons/FormArrow';

import styles from '../../../styles/buttons/form-arrow.scss';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const FormArrowButton = ({ className, ...props }) => {
    // console.log(props);
    return (
        <Button
            {...props}
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <FormArrowIcon />
        </Button>
    );
};

FormArrowButton.propTypes = propTypes;
FormArrowButton.defaultProps = defaultProps;

export default FormArrowButton;
